import { render, staticRenderFns } from "./gift-modal-confirmation.vue?vue&type=template&id=5a6b9413&scoped=true&"
import script from "./gift-modal-confirmation.vue?vue&type=script&lang=js&"
export * from "./gift-modal-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./gift-modal-confirmation.vue?vue&type=style&index=0&id=5a6b9413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b9413",
  null
  
)

export default component.exports